import React from 'react';
import styles from './Audio.module.scss';
import Actions from '../actions/Actions';
import ContentAudio from '../../../../components/content-audio/ContentAudio';

type Props = {
  data: string;
  isFullScreen: boolean;
};

function Audio(props: Props) {
  const { data, isFullScreen } = props;

  return (
    <Actions fullScreen={isFullScreen}>
      <div className={styles.content}>
        <ContentAudio data={data}/>
      </div>
    </Actions>
  );
}

export default Audio;
